import { render, staticRenderFns } from "./EditComment.vue?vue&type=template&id=279ed5e0&scoped=true"
import script from "./EditComment.vue?vue&type=script&lang=js"
export * from "./EditComment.vue?vue&type=script&lang=js"
import style0 from "./EditComment.vue?vue&type=style&index=0&id=279ed5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279ed5e0",
  null
  
)

export default component.exports